import { loadSessionIfPresent } from "@/helpers/heritage-integration/order-helper";
import { policyVehicleHasEndorsements } from "@/helpers/policy-vehicle-helper";
import { getSelectedPolicyVehicle } from "@/helpers/endorsements-helper";
import store from "@/store";
import { routeData } from "@/router/constants/routes";

export async function policyInfoBeforeEnter() {
    if (store.getters.order.policy.vehicleChangedDuringPolicyLookup) {
        if (policyVehicleHasEndorsements(getSelectedPolicyVehicle(store.getters.order))) {
            return {
                name: routeData.ENDORSEMENTS.name,
            };
        }
        return {
            name: routeData.POLICY_INFO_SUBMITTED.name,
        };
    }
    // The safelite api will often remove fees when switching cash to insurance.
    // Since the save session call to the safelite api does not return updated parts, we need to load the session
    // to get the updated parts.
    await loadSessionIfPresent(false, "policy-info");
}
